import { Accordion, Box, Text, AccordionButton, Heading, AccordionPanel, AccordionIcon, AccordionItem } from "@chakra-ui/react";
import React from "react";
import AppLayout from "../components/AppLayout";
import EventsList from "../components/EventsList";

export default function Main() {
    return (
        <AppLayout pageTitle={"Schedule | Hack+Policy Participant Portal"}>
            {/* <Heading mt="10" size="lg">Events Schedule</Heading> */}
            <EventsList />
        </AppLayout>
    )
}